import api from '@/lib/api';
import axios from 'axios';
import type { PlatformBranding, UpdatePlatformBrandingRequest } from '@workspace/types';
import { getApiBaseUrl } from '@/lib/httpClient';

type ApiResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
};

function unwrap<T>(response: { data: ApiResponse<T> }, fallback: string): T {
  if (!response.data.success || response.data.data === undefined) {
    throw new Error(response.data.error || response.data.message || fallback);
  }
  return response.data.data;
}

export const brandingApi = {
  async getPublicBranding(): Promise<PlatformBranding> {
    const response = await axios.get<ApiResponse<PlatformBranding>>(
      `${getApiBaseUrl()}/public/branding`,
      { timeout: 10000 },
    );
    return unwrap(response, 'Error al obtener branding');
  },

  async updateBranding(data: UpdatePlatformBrandingRequest): Promise<PlatformBranding> {
    const response = await api.put<ApiResponse<PlatformBranding>>('/admin/platform/branding', data);
    return unwrap(response, 'Error al actualizar branding');
  },
};
